import { useEffect, useState } from "react";
import { useSpot } from "../../../../Spot";
import { volumeCheckSpotStates } from "../volumeCheckSpotStates";

const renegadeSongShorter = require('../../../../../../assets/sounds/dances/Renegadev4_shorter.mp3');

/**
 * extends the functionality of useSpot for volume check
 */
export function useVolumeCheckSpot(speech, initialState){
    
    const spotHook = useSpot(speech, initialState)
    const { spotState, spotStates } = spotHook

    const [ volumeCheckSpotState, setVolumeCheckSpotState ] = useState(spotStates.invisible)

    /**
     * update the state here when the original Spot functionalities are used to change state.
     */
    useEffect(() => {
        setVolumeCheckSpotState(spotState)
    }, [spotState])
    

    /**
     * implement additional functionalities
     */
    const playDiscoBall = async () => {
        setVolumeCheckSpotState(volumeCheckSpotStates.discoBall)
        await speech.playAppSoundsWithPromise({
            url: renegadeSongShorter,
            key: 'renegadeSong',
        });
    }
    const playSingleBook = () => {
        setVolumeCheckSpotState(volumeCheckSpotStates.singleBook)
    }
    const playMultipleBooks = () => {
        setVolumeCheckSpotState(volumeCheckSpotStates.multipleBooks)
    }

    /**
     * return the extended version of the spot hook
     */
    return {
        ...spotHook, // copy spot's functionalities
        playDiscoBall,
        playSingleBook,
        playMultipleBooks,
        spotState: volumeCheckSpotState,
        spotStates: {
            ...spotStates,
            ...volumeCheckSpotStates // add additional available states
        },
    }
}